import { gql } from '@apollo/client';

export const WebPhotoFields = gql`
  fragment WebPhotoFields on OdProtosWebData_Photo {
    originalFilename
    fullSizeUrl
    thumbnailUrls {
      small
    }
  }
`;
